<template>
  <div>
    <back-nav to="VehicleDetailsReview" />
    <v-card class="tw-pb-12 tw-px-4">
      <card-title icon="mdi-autorenew">Policy Renewal Review</card-title>
      <div class="tw-px-0 md:tw-px-10 xl:tw-px-16">
        <div v-if="currentPolicy.covertypeId === 101">
          <v-card
              id="comprehensive"
              class="mx-auto md:tw-py-6 tw-bg-no-repeat tw-bg-right-bottom tw-bg-center tw-mt-4 md:tw-mt-8"
              outlined
              style="background-image: url(/images/icons/car-gray.png);"
          >
            <div class="tw-w-full tw-flex-wrap tw-flex">
              <div class="tw-w-full md:tw-w-7/12 tw-px-2 md:tw-px-8 tw-py-4 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400">
                <div class="tw-flex tw-flex-wrap">
                  <img src="/images/icons/car.png" class="tw-" alt="car icon">
                  <h3 class="c-blue-text title-font tw-text-base md:tw-text-2xl tw-px-3">Comprehensive <br> Insurance Cover</h3>
                </div>

                <div class="tw-mt-4">
                  <p class="c-blue-text tw-text-xl tw-font-bold" style="margin-bottom: 0px"> Confirm or Change sum insured</p>
                  <vuetify-money
                      id="amount1"
                      v-model.lazy="sumInsured"
                      label="Sum Insured"
                      type="text"
                      name="amount"
                      class="mx-4"
                      :rules="[required('Sum Insured'), minAmount('Sum Insured', 500000)]"
                      :options="options"
                      :disabled="sumUpdating"
                      v-debounce="delay"
                  ></vuetify-money>
                  <v-progress-circular
                      v-if="sumUpdating"
                      :size="25"
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                </div>

                <v-expansion-panels v-model="panel" :multiple="true" :flat="true" class="tw-mt-0 md:tw-mt-0" accordion>
                  <v-expansion-panel :readonly="true" class="tw-mt-2">
                    <v-expansion-panel-header :hide-actions="true" class="tw-mt-5 tw-text-white rounded-lg" color="primary">Additional Benefits</v-expansion-panel-header>
                    <v-expansion-panel-content class="tw-mt-5">
                      <p class="c-blue-text tw-text-base md:tw-text-xl">Review your benefits, you can add or remove</p>
                      <div class="tw-w-full tw-flex tw-flex-wrap tw-mt-5">
                        <div v-if="!isLoading" class="tw-w-full tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-pb-4">
                          <div class="tw-w-full tw-flex tw-mt-4" v-for="(benefit, $index) in compBenefits.benefits" :key="$index">
                            <label class="tw-flex tw-items-center" :for="'check-'+$index">
                              <input :id="'check-'+$index" type="checkbox" class="filled-in text-primary primary" v-model="addChargedBenefits" :value="{noOfBeneficiaries: 0, sectionCode: benefit.sectCode, sectionName: benefit.sectDesc.toUpperCase()}" :key="benefit.sectCode" :checked="false" :disabled="updatingAmount || selectedOther(benefit.sectCode) || sumInsured === 0" />
                              <ul>
                                <li>{{ benefit.sectDesc }}</li>
                                <li class="tw-mt-1"><span class="c-blue-text"> Sum of Kes {{benefit.rateType === 'Amount' ?  benefit.rate : benefitsInAmount(benefit, comprehensive.car.valueOfCar) | formatNum }}</span></li>
                                <transition name="slide">
                                  <li v-if="benefit.sectCode === 234 && isTravelEmbed" :key="'benefit'+$index">
                                    <p class="tw-text-xs tw-w-full">How many people would you cover?</p>
                                    <v-text-field
                                        v-model="beneficiaries"
                                        ref="beneficiaries"
                                        id="benefits"
                                        label="Add Beneficiaries (max 6)"
                                        type="number"
                                        :rules="[required('Beneficiaries'), min('Beneficiaries',benefit.minBeneficiary || travelEmbedMin), max('Beneficiaries', benefit.maxBeneficiary || travelEmbedMax)]"
                                        :disabled="updatingAmount"
                                    ></v-text-field>
                                  </li>
                                </transition>
                              </ul>
                            </label>
                          </div>
                        </div>
                        <div v-else class="tw-w-full tw-flex tw-justify-center">
                          <v-progress-circular
                              :size="50"
                              color="primary"
                              indeterminate
                          ></v-progress-circular>
                        </div>
                        <div>
                          <benefits-description />
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel class="tw-mt-8">
                    <v-expansion-panel-header color="primary1" class="tw-text-white">Benefits
                      <template v-slot:actions>
                        <v-icon color="#fff">$expand</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="tw-w-full tw-mt-3 md:tw-mt-5">
                      <benefits />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div class="tw-w-full md:tw-w-5/12 tw-px-2 md:tw-px-8 tw-py-4 tw-flex tw-flex-wrap tw-content-between ">
                <div class="tw-w-full tw-flex tw-flex-wrap">
                  <h3 class="c-blue-text title-font tw-text-xl md:tw-text-2xl tw-px-3">Premium Calculator</h3>
                  <div class="tw-w-full tw-mt-5 md:tw-mt-12">
                    <div class="tw-w-full tw-flex">
                      <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Basic premium</p>
                      <p class="c-gray-text tw-text-left">Kshs. {{ basicPremium(comprehensive) | formatNum }}</p>
                    </div>
                    <div v-if="benefits.length > 0" class="tw-my-3 lg:tw-my-5">
                      <p style="margin-bottom: 0px;">Additional Benefits</p>
                      <div v-for="(benefit, $i) in benefits" :key="$i" class="tw-w-full tw-flex tw-items-center tw-mt-1">
                        <p class="c-blue-text tw-w-7/12 md:tw-w-8/12 tw-pr-0 lg:tw-pr-3 tw-capitalize">{{ benefit.sectDesc.toLowerCase() }}</p>
                        <p class="c-gray-text">Ksh. {{ benefit.benefitPremium | formatNum}}</p>
                      </div>
                    </div>
                    <div class="tw-w-full tw-flex tw-mb-3 lg:tw-mb-6">
                      <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Levies</p>
                      <p class="c-gray-text"> Ksh. {{ levy(basicPremium(comprehensive) + sumChargedBenefits()) + pchf(basicPremium(comprehensive) + sumChargedBenefits()) | formatNum }}</p>
                    </div>
                  </div>
                </div>
                <div class="tw-w-full tw-mt-5 md:tw-mt-0">
                  <h4 class="c-blue-text tw-font-bold tw-text-sm">Renewal Premium</h4>
                  <h2 v-if="!updatingAmount" class="c-light-blue-text title-font tw-text-3xl md:tw-text-5xl">Ksh. {{ compAmount | formatNum }}</h2>
                  <v-progress-circular
                      v-else
                      indeterminate
                      color="primary"
                      class="tw-mt-3"
                  ></v-progress-circular>
                  <v-card-actions class="tw-w-1/2 tw-mt-2">
                    <v-btn block large
                           id="renewComp"
                           color="secondary"
                           class="my-3 "
                           @click="proceed"
                           :disabled="sumInsured < 500000"
                    >
                      {{ !sumInsured >= 500000 ? 'Update Sum Insured' : 'Continue'}}
                    </v-btn>
                  </v-card-actions>
                </div>
              </div>
            </div>
          </v-card>
        </div>

        <div v-else>
          <v-card
              id="thirdParty"
              class="mx-auto md:tw-py-6 tw-bg-no-repeat tw-bg-right-bottom tw-bg-center tw-mt-2 md:tw-mt-4"
              outlined
              style="background-image: url(/images/icons/car-gray.png);"
          >
            <div class="tw-w-full tw-flex-wrap tw-flex">
              <div class="tw-w-full md:tw-w-7/12 tw-px-2 md:tw-px-8 tw-py-4 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400 tw-flex tw-flex-wrap tw-content-between">
                <div class="tw-w-full">
                  <div class="tw-flex tw-flex-wrap">
                    <img src="/images/icons/car.png" class="tw-" alt="car icon">
                    <h3 class="c-blue-text title-font tw-text-base md:tw-text-2xl tw-px-3">Third Party Only <br> Insurance Cover</h3>
                  </div>

                  <v-expansion-panels v-model="panel2" :readonly="true" :flat="true" class="tw-mt-5 md:tw-mt-8" accordion>
                    <v-expansion-panel>
                      <v-expansion-panel-header :hide-actions="true" color="primary1" class="tw-text-white">Benefits</v-expansion-panel-header>
                      <v-expansion-panel-content class="tw-w-full tw-mt-3 md:tw-mt-5">
                        <third-party-benefits />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>
              <div class="tw-w-full md:tw-w-5/12 tw-px-2 md:tw-px-8 tw-py-4 tw-flex tw-flex-wrap tw-content-between ">
                <div class="tw-w-full tw-flex tw-flex-wrap">
                  <h3 class="c-blue-text title-font tw-text-xl md:tw-text-1xl tw-px-3">Premium Calculator</h3>
                  <div class="tw-w-full tw-mt-5 md:tw-mt-6">
                    <div class="tw-w-full tw-flex">
                      <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Basic premium</p>
                      <p class="c-gray-text tw-text-left">Kshs. {{ (thirdAmount - (levy(thirdAmount) + pchf(thirdAmount) )) | formatNum }}</p>
                    </div>
                    <div class="tw-w-full tw-flex">
                      <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Levies</p>
                      <p class="c-gray-text">Ksh {{ levy(thirdAmount) + pchf(thirdAmount) | formatNum }}</p>
                    </div>
                  </div>
                </div>
                <div class="tw-w-full tw-mt-3 md:tw-mt-6">
                  <h4 class="c-blue-text tw-font-bold tw-text-sm">Renewal Premium</h4>
                  <h2 class="c-light-blue-text title-font tw-text-3xl md:tw-text-5xl">Ksh. {{ thirdAmount | formatNum }}</h2>
                  <v-card-actions class="tw-w-1/2 tw-mt-2">
                    <v-btn block large
                           id="buyThird"
                           color="secondary"
                           class="my-3 "
                           @click="proceed"
                    >
                      Continue
                    </v-btn>
                  </v-card-actions>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable sonarjs/no-duplicate-string */

import CardTitle from '@/components/shared/CardTitle';
import validations from '@/utils/validations';
import helpers from '@/utils/helpers';
import Benefits from '@/components/shared/Benefits';
import ThirdPartyBenefits from '@/components/shared/ThirdPartyBenefits';
import axios from 'axios';
import { formatDate, formatDate2, changeFormat } from '@/utils/time';
import debounce from 'v-debounce';
import BenefitsDescription from '@/components/shared/BenefitsDescription';
import BackNav from '@/components/buy/BackNav';
import {
  FB_RENEW_UPDATE_SUM_INSURED,
  FB_RENEW_UPDATE_BENEFITS,
  FB_RENEW_POLICY_REVIEW,
  MINIMUM_COMP_PREMIUM,
  MINIMUM_EXCESS_PROTECTOR_PREMIUM,
} from '@/utils/const';

export default {
  name: 'PolicyReview',
  props: ['renewal'],
  components: {
    BackNav,
    BenefitsDescription,
    ThirdPartyBenefits,
    Benefits,
    CardTitle,
  },
  data() {
    return {
      options: {
        locale: 'en',
        prefix: 'Kes',
        suffix: '',
        // length: 9,
        precision: 0,
      },
      panel: [0],
      panel2: 0,
      ...validations,
      addChargedBenefits: [],
      updatingAmount: false,
      finalData: {},
      sumInsured: this.$store.getters['renewal/fetchQoute'].covertypes.find((id) => id.selected === 'Y').car.valueOfCar,
      isLoading: true,
      coverTypes: [],
      beneficiaries: 0,
      compAmount: this.$store.getters['renewal/fetchQoute'].covertypes.find((id) => id.selected === 'Y').riskPremDto.totalPremium,
      thirdAmount: this.$store.getters['renewal/fetchQoute'].covertypes.find((id) => id.selected === 'Y').riskPremDto.totalPremium,
      sumUpdating: false,
      form: {},
      loading: false,
      delay: 1000,
      pageLoading: true,
      benefits: [],
      travelEmbedMin: 1,
      travelEmbedMax: 6,
    };
  },
  computed: {
    quote() {
      return this.$store.getters['renewal/fetchQoute'];
    },
    comprehensive() {
      return this.quote.covertypes.find((id) => id.covertypeId === 101) || { car: { valueOfCar: 0 } };
    },
    thirdParty() {
      return this.quote.covertypes.find((id) => id.covertypeId === 106) || { car: { valueOfCar: 0 } };
    },
    currentPolicy() {
      return this.quote.covertypes.find((id) => id.selected === 'Y') || this.quote.covertypes.find((id) => id.covertypeId === 101);
    },
    compBenefits() {
      return this.coverTypes.find((c) => c.code === 101);
    },
    thirdBenefits() {
      return this.coverTypes.find((c) => c.code === 106);
    },
    isTravelEmbed() {
      return this.addChargedBenefits.length > 0 ? !!this.addChargedBenefits.find((e) => e.sectionCode === 234) : false;
    },
  },
  watch: {
    sumInsured(val) {
      if (val && val >= 500000) this.updateSumInsured(val);
    },
    addChargedBenefits(val) {
      if (val.length > 0) {
        if (val.filter((e) => e.sectionCode === 234).length === 0) {
          this.updateChargedBenefits(val);
        } else if (val.find((e) => e.sectionCode === 234) && (this.beneficiaries >= 1 && this.beneficiaries <= 6)) {
          const values = [];
          let index;
          this.addChargedBenefits.forEach((v) => {
            values.push(v);
          });
          const original = this.compBenefits.benefits.find((x) => x.sectCode === 234);
          if (original) {
            // eslint-disable-next-line prefer-const
            index = values.findIndex((x) => x.sectionCode === 234);
            // eslint-disable-next-line no-param-reassign
            values[index] = { noOfBeneficiaries: this.beneficiaries, sectionCode: original.sectCode, sectionName: original.sectDesc };
            this.updateChargedBenefits(values);
          }
        }
      } else {
        this.updateChargedBenefits([]);
      }
    },
    beneficiaries(val) {
      let index;
      const values = [];
      this.addChargedBenefits.forEach((v) => {
        values.push(v);
      });
      if (values.find((e) => e.sectionCode === 234) && (this.beneficiaries >= 1 && this.beneficiaries <= 6)) {
        const original = this.compBenefits.benefits.find((x) => x.sectCode === 234);
        if (original !== undefined) {
          index = values.findIndex((x) => x.sectionCode === 234);
          // eslint-disable-next-line no-param-reassign
          values[index] = { noOfBeneficiaries: val, sectionCode: original.sectCode, sectionName: original.sectDesc };
          this.updateChargedBenefits(values);
        }
      }
    },
  },
  mounted() {
    this.fetchCoverTypes().then((cover) => {
      this.coverTypes = cover;
      this.isLoading = false;
      if ('additionalBenefits' in this.currentPolicy) {
        this.currentPolicy.additionalBenefits.forEach((b) => {
          this.addChargedBenefits.push({
            noOfBeneficiaries: 0,
            sectionCode: b.id,
            sectionName: b.sectionName,
          });
        });
        const travelEmbed = this.currentPolicy.additionalBenefits.find((e) => e.id === 234);
        if (travelEmbed) {
          this.beneficiaries = travelEmbed.noOfBeneficiaries;
        }
      }
    });
    this.form = {
      carDTOS: [this.currentPolicy.car],
      coverFrom: this.changeFormat(this.quote.coverFrom),
      coverTypeID: 0,
      dateFormat: 'dd/MM/yyyy',
      documents: this.quote.document,
      email: this.quote.client.email,
      fullName: this.quote.client.fullName,
      idNumber: this.quote.client.idNumber,
      pinNumber: this.quote.client.kraPinNumber,
      mobileNumber: this.quote.client.mobileNumber,
      paymentStatus: false,
      planChanged: false,
      premium: 0.0,
      prodId: this.currentPolicy.productCode,
      quoteId: this.quote.quoteId,
      selectedRiskId: this.currentPolicy.riskId,
      status: 0,
      timestamp: 0,
    };
  },
  methods: {
    proceed() {
      this.$analytics.logEvent(FB_RENEW_POLICY_REVIEW, { product: 'Renewal Journey Policy Review' });
      this.$emit('cover-summary-review', this.renewal);
    },
    sumChargedBenefits() {
      if (this.benefits.length > 0) {
        return this.benefits.reduce((sum, current) => sum + current.benefitPremium, 0);
      }
      return 0;
    },
    levy(amount) {
      return Math.ceil((0.2 / 100) * amount);
    },
    pchf(amount) {
      return Math.ceil((0.25 / 100) * amount);
    },
    benefitsInAmount(benefit, premium) {
      const amount = Math.ceil((benefit.rate / benefit.divFactor) * premium);
      if (benefit.sectCode === 1614 && amount < MINIMUM_EXCESS_PROTECTOR_PREMIUM) {
        return MINIMUM_EXCESS_PROTECTOR_PREMIUM;
      }
      return amount;
    },
    basicPremium(comprehensive) {
      const amount = Math.ceil(parseInt(comprehensive.car.valueOfCar, 10) * (comprehensive.rateApplied / 100));
      if (amount < MINIMUM_COMP_PREMIUM) {
        return MINIMUM_COMP_PREMIUM;
      }
      return amount;
    },
    fetchCoverTypes() {
      return axios.get(`/customer/gis/products/${this.currentPolicy.productCode}/covertypes`).then((response) => Promise.all(response.data.object.map(async (el) => {
        const o = { ...el };
        // eslint-disable-next-line no-shadow
        o.benefits = await axios.get(`/customer/gis/products/${this.currentPolicy.productCode}/covertypes/${el.code}/chargeablebenefits`).then((benefit) => benefit.data.object);
        return o;
      })));
    },
    async updateSumInsured(sumInsured) {
      this.sumUpdating = true;
      let { form } = this;
      if (this.currentPolicy.covertypeId === 106) {
        form = { ...this.form, ...{ planChanged: true } };
      }
      await axios.put('/customer/quotation/update', {
        ...form,
        ...{
          carDTOS: [
            {
              ...this.currentPolicy.car, ...{ valueOfCar: parseInt(sumInsured, 10) },
            }],
        },
      })
        .then(() => {
          this.$store.dispatch('renewal/fetchQuotation', this.$route.params.batchNo).then(() => {
            this.sumUpdating = false;
            this.compAmount = this.quote.covertypes.find((id) => id.covertypeId === 101).riskPremDto.totalPremium;
            this.thirdAmount = this.quote.covertypes.find((id) => id.covertypeId === 106) ? this.quote.covertypes.find((id) => id.covertypeId === 106).riskPremDto.totalPremium : 0;
          });
          this.$analytics.logEvent(FB_RENEW_UPDATE_SUM_INSURED, { product: 'Renewal Journey Update sum insured' });
        });
    },
    updateChargedBenefits(body) {
      this.updatingAmount = true;
      const data = {
        benefits: body,
        riskId: this.currentPolicy.riskId,
      };
      axios.post('/customer/quotation/benefit/change', data)
        .then((response) => {
          this.compAmount = response.data.totalPremium;
          this.benefits = response.data.benefits;
          this.updatingAmount = false;
          this.$analytics.logEvent(FB_RENEW_UPDATE_BENEFITS, { product: 'Renewal Journey Update Benefits' });
        });
    },
    selectedOther(code) {
      if (code === 85) {
        return !!this.addChargedBenefits.find((e) => e.sectionCode === 18422);
      }
      if (code === 18422) {
        return !!this.addChargedBenefits.find((e) => e.sectionCode === 85);
      }
      return false;
    },
    formatDate,
    formatDate2,
    changeFormat,
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
  directives: {
    debounce,
  },
};
</script>
